var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md:pt-20 pt-16"},[_c('heroSection'),_c('serviseSection'),_c('WhyChose'),_c('CountingSec')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }